/**
 * Icon bar component used for the front page. 
 */
 import React from 'react';
 import * as styles from 'src/uglib_styles/libSocials.module.css';
  
 function LibSocials () {
 

    const twitter_classes = ["fab", "fa-square-x-twitter", styles.icon].join(' ');
    const facebook_classes = ["fab", "fa-facebook", styles.icon].join(' ');
    const youtube_classes = ["fab", "fa-youtube", styles.icon].join(' ');
    const instagram_classes = ["fab", "fa-instagram", styles.icon].join(' ');
    const news_classes = ["fa-regular", "fa-newspaper", styles.icon].join(' ');
     return (<>
        <div className={styles.ug_socials}>
            <ul>
                <li>
                    <a href="https://www.lib.uoguelph.ca/news" className={styles.news}><span className={news_classes} /><span className="sr-only">Subscribe to the Library Newsletter</span></a>
                </li>
                <li>
                    <a href="https://www.twitter.com/uglibrary" className={styles.twitter}><span className={twitter_classes} /><span className="sr-only">Follow us on twitter</span></a>
                </li>
                <li>
                    <a href="https://www.facebook.com/McLaughlinLibrary" className={styles.facebook}><span className={facebook_classes} /><span className="sr-only">Like us on Facebook</span></a>
                </li>
                <li>
                    <a href="https://www.youtube.com/user/UoGLibrary" className={styles.youtube}><span className={youtube_classes} /><span className="sr-only">Subscribe on YouTube</span></a>
                </li>
                <li>
                    <a href="https://www.instagram.com/uglibrary" className={styles.instagram}><span className={instagram_classes} /><span className="sr-only">Follow us on Instagram</span></a>
                </li>
            </ul>
        </div>
    </>)
     
 }
 
  
  export default LibSocials